import { logUsage } from 'owa-analytics';
import { trace } from 'owa-trace';
import GetCertsInfoResponse from 'owa-service/lib/contract/GetCertsInfoResponse';
import getCertsInfoOperation from 'owa-service/lib/operation/getCertsInfoOperation';

/**
 * Returns the information about Digital Signature using raw signature data
 * @param certRawData
 * @param isSend
 */

const CertificateVerificationResultEventName = 'CertificateVerificationResult';

const getCertInfoFromServer = async (
    certRawData: string,
    isSend: boolean
): Promise<GetCertsInfoResponse> => {
    if (!certRawData) {
        trace.error('SmimeTraceError: Certificate data empty');
        return null;
    }
    try {
        const result: GetCertsInfoResponse = await getCertsInfoOperation({ certRawData, isSend });
        logUsage(CertificateVerificationResultEventName, {
            isValid: result.IsValid,
            isSend,
        });
        return result;
    } catch (e) {
        /**
         * Currently, no S/MIME infobar exist for this case in JSMVVM
         * JSMVVM shows 'Message isn't valid or trusted' infobar but in reality
         * we failed to verify this from server
         */
        trace.error('SmimeTraceError: getCertInfo request failed');
        logUsage(CertificateVerificationResultEventName, {
            error: e,
        });
        return null;
    }
};

export default getCertInfoFromServer;
